export default {"src":"/polygon/_next/static/media/meshswap.b13523f6.svg","height":48,"width":48};